// src/components/Service.js
import React from "react";

const vehicles = [

{
  id: 12,
  name: "Airport Cab Service",
  image: "/images/Airport-Cab-Service.jpg",
  link: "",
  desc: "24×7 airport pickup and drop service with on-time arrivals, flight tracking, and experienced drivers."
},

{
  id: 4,
  name: "Mumbai Airport Cab Service",
  image: "/images/Services/Mumbai-Airport-Cab-Service.jpg",
  link: "/mumbai-airport-cab-service",
  desc: "Timely airport pickup and drop services with comfortable AC cabs."
},
{
  id: 5,
  name: "Mumbai Airport to Pune Cab",
  image: "/images/Services/Mumbai-Airport-to-Pune-Cab.jpg",
  link: "/mumbai-airport-to-pune-cab",
  desc: "Safe and comfortable one-way and round-trip cab service between Mumbai Airport and Pune."
},
{
  id: 6,
  name: "Mumbai Airport to Surat Cab",
  image: "/images/Services/Mumbai-Airport-to-Surat-Cab.jpg",
  link: "/mumbai-airport-to-surat-cab",
  desc: "Comfortable long-distance taxi service from Mumbai Airport to Surat."
},
{
  id: 11,
  name: "Business Travel Cab Service",
  image: "/images/Business-Travel-Cab-Service.jpg",
  link: "",
  desc: "Professional cab service for corporate meetings, business trips, and travel with comfortable rides."
},
{
  id: 7,
  name: "Mumbai Outstation Cabs",
  image: "/images/Services/Mumbai-Outstation-Cabs.jpg",
  link: "/mumbai-outstation-cabs",
  desc: "Premium outstation taxi service for weekend trips, business travel and family tours."
},
{
  id: 9,
  name: "Navi Mumbai Cab Service",
  image: "/images/Services/Navi-Mumbai-Cab-Service.jpg",
  link: "/navi-mumbai-cab-service",
  desc: "Reliable cab booking in Navi Mumbai for local, airport and outstation travel."
},
{
  id: 13,
  name: "One-Way Drop Service",
  image: "/images/One-Way-Drop-Service.jpg",
  link: "",
  desc: "Affordable one-way cab service for intercity and outstation travel without paying for a return trip."
},
{
  id: 10,
  name: "Navi Mumbai International Airport Cab",
  image: "/images/Services/Navi-Mumbai-International-Airport-Cab.jpg",
  link: "/navi-mumbai-international-airport-cab",
  desc: "Airport transfer service with professional drivers and clean vehicles."
},
  {
  id: 1,
  name: "Cab Service in Thane",
  image: "/images/Services/Cab-Service-in-Thane.jpg",
  link: "/cab-service-in-thane",
  desc: "Reliable local, airport and outstation cab services in Thane with professional drivers."
},
{
  id: 2,
  name: "Cab Services in Mumbai",
  image: "/images/Services/Cab-Services-in-Mumbai.jpg",
  link: "/cab-services-in-mumbai",
  desc: "24×7 Mumbai cab booking for airport transfers, local rides and outstation journeys."
},
{
  id: 3,
  name: "Cheapest Cab Service in Mumbai",
  image: "/images/Services/Cheapest-Cab-Service-in-Mumbai.jpg",
  link: "/cheapest-cab-service-in-mumbai",
  desc: "Affordable taxi services in Mumbai with clean vehicles and transparent pricing."
},
];

const Service = () => {
  return (
    <>
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container z-index-common">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Services </h1>
          </div>
        </div>
      </div>



     

      <div className="section-full py-5 site-bg-white twm-cars-section-wrap">
        <div className="container">
          <div className="section-content">
            <div className="twm-cars-section m-b30">
              <div className="row">
                {vehicles.map((vehicle) => (
                  <div
                    key={vehicle.id}
                    className="col-lg-4 col-md-6 m-b30 wow fadeInDown"
                    data-wow-delay="0.2s"
                  >
                    <div className="twm-vehicle-fleet-bx twm-custom-grid-3 ">
                      {/* <div className="twm-media twmtitle">
                        <div className="twm-media-pi borderrr twmtitle text-center">
                          <img src={vehicle.image} alt={vehicle.name} />
                        </div>
                      </div> */}
                      <div className="service-card">

    <div className="service-image">

        <img src={vehicle.image} alt={vehicle.name} />

        <span className="service-badge">
            Airport Cab
        </span>

    </div>

    <div className="service-content">

        <h3>{vehicle.name}</h3>

        <p>{vehicle.desc}</p>

        <a href={vehicle.link} className="service-btn">
            Read More
        </a>

    </div>

</div>
                      {/* <div className="twm-vehicle-fleet-content ">
                        <h3 className="twm-v-title twmtitle twmtitle text-center">
                          <a className="twmtitle text-center darkcolo" >{vehicle.name}</a>
                        </h3>
                        <ul className="twm-vehicle-facility">
                          <li>{vehicle.desc}</li>
                        </ul>
                      </div> */}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Service;